import { renderPageInModal, initComponent } from "@api/utils_2020";
const swipeCSS = require("photoswipe/dist/photoswipe.css");
const swipeUI = require("photoswipe/dist/default-skin/default-skin.css");

export default () => {

    var languageQr = window.location.href.substring(window.location.href.indexOf("language-qrcode"));
    if (languageQr == 'language-qrcode') {
        $("#languages-modal").addClass("show");
        $("body").addClass("showModal");

    }
    // got to group in modal
    //$('body').off('click','#productslist .pb-productsdetails .more > a:not(.jsFavorite)').on('click','#productslist .pb-productsdetails .more > a:not(.jsFavorite)',function(e)

    $('bodyXX').off('click', '.pb-productgroupnav a:not(.favorite-cta), .pb-productgroupofficinalist .scroll-container li a:not(.favorite-cta), .pb-productgrouppretlist .scroll-container li a:not(.favorite-cta)').on('click', '.pb-productgroupnav a:not(.favorite-cta), .pb-productgroupofficinalist .scroll-container li a:not(.favorite-cta), .pb-productgrouppretlist .scroll-container li a:not(.favorite-cta)', function (e) {
        e.preventDefault();
        const link = $(this).attr('href');


        function initPage() {
            import( /* webpackChunkName: "/product" */ "./product.js").then((module) => module.default());

            initComponent('pb-productheader-v2');
            initComponent('pb-relatedproducts');
            initComponent('pb-productgroupcarousel');
            initComponent('pb-archtrendscarousel-v3');
            initComponent('pb-findstore--static');
        }

        renderPageInModal(link, '#Product_view', initPage);
        return false;
    });



    $('body').off("click", '.jsEmbed').on("click", '.jsEmbed', function (e) {
        e.preventDefault();
        var embedLink = $(this).data("embed"); //
        var title = $(this).data("title"); //
        var content = $(this).data("content"); //
        var target = $(this).data("target"); //


        var embed =
            '<iframe class="embed" src="' +
            embedLink + //.replace('youtube','youtube-nocookie')
            '" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen allow="xr-spatial-tracking"></iframe>';
        UtilUi.loadTemplate("assets/modal-embed-content.tpl", function (dataContact, tpl) {
            var html = tpl.fetch({
                firstLanguage: lang,
                title: title,
                urlImageServer: urlImageServer,
                urlHome: urlhome,
                embed: embed,
                embedLink: embedLink,
                content: content,
                target: target,
                lang: lang
            });
            $("body").append(html);
            $("body").addClass("noScroll");
            $('a.expandEmbed').on('click', function (e) {
                $('.embed').addClass('expanded');

            });
            $("#embed-content-modal").fadeIn();

        });
        return false;
    });

    $('body').on('click', '#embed-content-modal a.btn-close', function (e) {
        e.preventDefault();
        $("#embed-content-modal").fadeOut('fast', function () {
            $(this).remove();
            $("body").removeClass("noScroll");
        });
        return false;
    });

    $('body').on('click', '.pb-archtrendscarousel-v3 a.btn-see-more', function () {
        var url = window.location.href;
        url = url.split('?');
        url = url[0];
        window.dataLayer.push({
            'event': "produtos_projetos_archtrends",
            'click_text': 'ver mais projetos',
            'click_url': url
        });
    });

    const portobelloService = Util.service("WSPortobelloSite", true, {
        exceptionHandler: console.error,
        reflectSuccess: function (pbSiteService) {
            return pbSiteService;
        },
        reflectError: function () {
            console.error("Erro de conexão, verifique sua conexão com a internet.");
        },
    });

    let zipInterval;
    $('body').off('click', '.pb-downloads--buttons a[href="#zipsketchup"]').on('click', '.pb-downloads--buttons a[href="#zipsketchup"]', function (e) {
        e.preventDefault();
        const idProduct = $(this).data('idproduct');
        const type = $(this).data('type');

        portobelloService.addZipToQueue(idProduct, type, {
            success: items => {
                if (items) {
                    if (items.hasZip) {
                        let link = document.createElement('a');
                        link.href = items.hasZip;
                        document.body.appendChild(link);
                        link.click();
                        document.body.removeChild(link);
                    } else if (items) {
                        //UtilUi.loadTemplate("assets/components/pb-list--zip/pb-list--zip.tpl", (dataOn, tpl) => {
                            let zipItems = Object.values(items);
                            let html = tpl.fetch({ zipItems });
                            $("body").append(html);

                            zipInterval = setInterval(() => {
                                portobelloService.getMyZipList({
                                    success: refreshItems => {
                                        if (refreshItems) {
                                            UtilUi.loadTemplate("assets/components/pb-list--zip/pb-zip--items.tpl", (dataOn, tpl) => {
                                                zipItems = Object.values(refreshItems);
                                                html = tpl.fetch({ zipItems });
                                                $("#selected-list .items").html(html);
                                                $('#pb-modal--productdetails button[data-dismiss="modal"]').trigger('click');
                                            });
                                        } else {
                                            $("#selected-list").remove();
                                            clearInterval(zipInterval);
                                        }
                                    }
                                })
                            }, 10000);
                        //});
                    }
                } else {
                    alert('Houve um erro na requisição do seu download, tente novamente mais tarde!')
                }
            }
        })

        return false;
    });

};
